const loadNavigation = ({ api, navigationId }) => {
    const url = `${api}/v1/navbars/${navigationId}`;
    return fetch(url).then(response => {
        if (response.status !== 200) {
            throw new Error(`Unable to load Navigation ${navigationId}`);
        }
        return response.json();
    }).catch(err => {
        // eslint-disable-next-line no-console
        console.error(err);
        return false;
    });
};

export default loadNavigation;
